<template>
  <div>
    <a-drawer ref="approvalInstanceDrawer" placement="right" :visible="visible" :width="currentDrawerWidth"
      @close="onClose" :maskClosable="false">
      <template slot="title">
        <div class="drawer-title">
          <div class="drawer-title-left">
            <small class="back-icon" @click="onClose"><a-icon type="left" />&nbsp;返回</small>
            <span>审批详情</span>

            <img
              class="dingding-icon"
              v-if="details.dingProcessInstanceId"
              src="@/assets/oa/dingding.svg"
              alt="dingding"
            />
          </div>
          <!-- <a-icon :type="isFullscreen ? 'fullscreen-exit' : 'fullscreen'" @click="toggleScreen" /> -->
        </div>
      </template> 
      <div v-if="processActionList.length" class="drawer-content" id="drawer-content">
        <div class="title">
          <div class="avatar-box">
            <div class="avatar">{{ getShortName(details.createBy) }}</div>
            <span style="color: #19191a">{{ details.createBy }}</span>
          </div>
          <div class="title-info">
            <div class="form-title">
              <template v-if="isEditingFormTitle">
                <a-input v-model="editingFormTitle" @pressEnter="saveFormTitle" @blur="saveFormTitle"
                  style="width: 500px; margin-right: 8px" size="small" ref="formTitleInput" />
                <a-icon type="check" style="
                    cursor: pointer;
                    color: #52c41a;
                    font-size: 16px;
                    margin-right: 4px;
                  " @click="saveFormTitle" title="保存" />
                <a-icon type="close" style="
                    cursor: pointer;
                    color: #ff4d4f;
                    font-size: 16px;
                    margin-right: 4px;
                  " @click="cancelEditFormTitle" title="取消" />
              </template>
             
              <a-tag :color="(Number.isInteger(details.state) &&
                stateAction[details.state][0]) ||
                ''
                ">{{
                  Number.isInteger(details.state) &&
                  stateAction[details.state][1]
                }}</a-tag>
            </div>
            <div class="serial-number">
              流水号：
              <CopyText :copyVal="details.serialNumber" />
            </div>
            <div v-if="auditDeadline">
              审核截止时间：
              <strong>{{ auditDeadline }}</strong>
              <div class="count-down" v-if="isDely">
                倒计时：
                <a-statistic-countdown :value="auditDeadline" format="D 天 H 时 m 分 s 秒" />
              </div>
              <!-- <div class="count-down" v-else style="margin-left: 0">
                <span> 已超时: {{ computedOverTime }} </span>
              </div> -->
            </div>
          </div>
          <!-- 手机扫码移动端 -->
          <!-- <div class="extend-options">
            <a-tooltip
              title="模板打印"
              placement="left"
              v-if="[88, 115, 116].includes(details.formId)"
            >
              <span style="cursor: pointer" @click="printTemplateHandle">
                <a-icon type="printer" style="font-size: 20px" />
                模板打印
              </span>
            </a-tooltip>
            <a-tooltip title="打印" placement="left">
              <span style="cursor: pointer" @click="printPreviewHandle">
                <a-icon type="printer" style="font-size: 20px" />
                打印
              </span>
            </a-tooltip>
          </div> -->
        </div>
        <img class="status-icon" alt="approval-status" v-if="details.state" :src="Number.isInteger(details.state) && stateAction[details.state][2]
          " :class="{ 'animate-stamp': animateStamp }" />
        <div class="process-content" :style="approvalInstanceDrawerStyle">
          <a-spin :spinning="dataLoading">
            <div class="form-render">
              <table border="1" class="form-table">
                <tr v-for="(item, index) in details.formData" :key="index">
                  <template v-if="showComponent(item.componentType)">
                    <th :colspan="4">
                      <div class="layout-title span-layout-title">
                        <label class="required-mark" v-if="item.props && item.props.required">*</label>
                        <span>{{ item.name }}</span>
                      </div>
                    </th>
                  </template>

                  <template v-else-if="
                    [
                      'TableField',
                      'DDPhotoField',
                      'DDAttachment',
                      'TextareaField',
                      'OaProcessField',
                    ].includes(item.componentType) && !item.isRelatedDisplay
                  ">
                    <th :colspan="1" class="form-label" width="180">
                      <!-- v-if="!['TableField'].includes(item.componentType)" 隐藏明细表label? -->
                      <label class="required-mark" v-if="item.props && item.props.required">*</label>
                      <span>{{ item.name }}</span>
                    </th>
                    <td :colspan="['TableField'].includes(item.componentType) ? 4 : 3
                      ">
                     
                      <div v-if="item.componentType === 'DDAttachment'">
                         <ul>
                          <li class="file-privew-item" v-for="v in formatFileList(item)" :key="v.id">
                            <div class="link-file" :title="v.title"  >
                               {{ v.title }}
                            </div>
                            <div style="margin-left: auto; white-space: nowrap">
                              <a-tag size="mini" color="blue">{{
                                formatFileSize(v.size)
                                }}</a-tag>
                               
                            </div>
                          </li>
                        </ul>
                      </div> 
                      
                    </td>
                  </template>

               
                  <template v-else>
                    <template v-if="!item.isRelatedDisplay">
                      <th colspan="1" width="180" class="form-label">
                        <label class="required-mark" v-if="item.props && item.props.required">*</label>
                        <span>{{ item.name }}</span>
                      </th>
                      <td colspan="1">
                        <template>
                          <div v-if="item.componentType === 'DDMultiSelectField'">
                            <a-tag v-for="(v, i) in item.extValue &&
                              JSON.parse(item.extValue)" :key="i">{{ v }}</a-tag>
                          </div>
                          <div class="form-item-value" v-else-if="
                            item.componentType === 'DDDateRangeField'
                          ">
                            {{ item.extValue && JSON.parse(item.extValue)[0] }}
                            ~
                            {{ item.extValue && JSON.parse(item.extValue)[1] }}
                          </div>
                          <div class="user-list" v-else-if="
                            item.componentType === 'InnerContactField'
                          ">
                            <div class="avatar-box" v-for="user in item.extValue &&
                              JSON.parse(item.extValue)" :key="user.id">
                              <div class="avatar">
                                {{ getShortName(user.name) }}
                              </div>
                              <div style="
                                  color: #19191a;
                                  height: 28px;
                                  line-height: 28px;
                                ">
                                {{ user.name }}
                              </div>
                            </div>
                          </div>

                          <div v-else-if="isAttachmentBizAlias(item)">
                            <ul>
                              <li class="file-privew-item" v-for="v in formatFileList(item)" :key="v.id">
                                <div class="link-file" :title="v.title" @click="kkFilePreview(v)">
                                  <img :src="splitFileType(v.title)" style="width: 18px" />
                                  {{ v.title }}
                                </div>
                                <div style="margin-left: auto; white-space: nowrap">
                                  <a-tag size="mini" color="blue">{{
                                    formatFileSize(v.size)
                                    }}</a-tag>
                                  <a-button size="small" type="primary" ghost icon="download" v-if="showDownload"
                                    @click="previewFileHandle(v)">下载</a-button>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div v-else class="form-item-value">
                            <div v-html="getAmountDisplayValue(item)"></div>
                          </div>
                        </template>
                      </td>
                    </template>
                  </template>
                </tr>
              </table>

              <!-- 动态指定审批人 -->
              <a-form-model ref="dyForm" :model="form" :rules="rules" v-if="form.taskId">
                <a-form-model-item v-for="(dynamicItem, index) in dynamicActiveNodeItems" :key="dynamicItem.id"
                  :prop="`variables.${dynamicItem.id}_users`" :colon="false">
                  <template slot="label">
                    指定节点【<b>{{ dynamicItem.name }}</b>】审批人<a-tag color="blue"
                      v-if="showSelfSelectMultiple(dynamicItem)">{{ showSelfSelectMultiple(dynamicItem) }}（多选）</a-tag>
                  </template>
                  <div class="user-list">
                    <div class="avatar-box" v-for="user in dynamicAssigneeList[index]" :key="user.id">
                      <div class="avatar">
                        {{ getShortName(user.name) }}
                      </div>
                      <div style="color: #19191a; height: 28px; line-height: 28px">
                        {{ user.name }}
                      </div>
                      <i class="close el-icon-close" @click="removeUser(user, index)"></i>
                    </div>
                    <div class="avatar-box">
                      <i class="el-icon-plus add-user" @click="handleAddUser(index)"></i>
                      <span class="name">指定</span>
                    </div>
                  </div>
                </a-form-model-item>
                <a-form-model-item label="审批意见" :colon="false">
                  <a-textarea v-model="form.comment" placeholder="请输入审批意见" :rows="5" />
                </a-form-model-item>
              </a-form-model>
            </div>
            <!-- 评论附件 -->
            <div class="attachment-warp" v-if="attachmentListAction.length">
              <div class="comment-warp" style="margin-left: 0px; padding-top: 10px" v-for="item in attachmentListAction"
                :key="item.executionTime">
                <div class="comment-user">
                  <div class="avatar" style="width: 30px; height: 30px">
                    <span style="font-size: 12px">{{
                      getShortName(item.actorFullName)
                      }}</span>
                  </div>
                  <div>
                    <span>{{ item.actorFullName }}（添加了评论）</span>
                    <a-button v-if="showRevokedBtn(item.actorFullName)" type="link" icon="undo" class="revoke-btn"
                      title="撤销" @click="revokedAction(item)"></a-button>
                  </div>
                  <span class="time">{{ formatDate(item.executionTime) }}</span>
                </div>
                <div class="comment-desc">
                  <pre class="comment-text">{{
                    item.params && item.params.comment
                  }}</pre>
                  <!-- 图片 -->
                  <div class="list-photo" v-if="
                    item.params &&
                    item.params.attachFile &&
                    item.params.attachFile.length
                  ">
                    <img :preview="img.fileId" v-for="img in filterImgGroup(item, 1)" :key="img.fileId"
                      :src="fullPath(img.filePath)" alt="img" @click="previewImage" />
                  </div>
                  <!-- 附件 -->
                  <div v-if="
                    item.params &&
                    item.params.attachFile &&
                    item.params.attachFile.length
                  ">
                    <ul>
                      <li class="file-privew-item" v-for="v in filterImgGroup(item, 2)" :key="v.fileId">
                        <div class="link-file" style="width: 84%" :title="v.fileName" @click="kkFilePreview(v)">
                          <img :src="splitFileType(v.fileName)" style="width: 18px" />
                          {{ v.fileName }}
                        </div>
                        <a-button style="margin-left: auto" size="small" type="primary" ghost v-if="showDownload"
                          icon="download" @click="previewFileHandle(v)">下载</a-button>
                      </li>
                    </ul>
                  </div>
                </div>
                <a-divider />
              </div>
            </div>
            <!-- 流程定义 -->
            <div class="process" style="margin-top: 16px">
              <!-- 过滤显示条件分支节点 -->
              <div class="process-item progress-item-his" v-for="(item, i) in uniqueProcessActionList" :key="i">
                <div class="item-user">
                  <div class="item-user-avatar">
                    <div class="avatar">
                      <template v-if="item.type === 'CC'">
                        <span style="font-size: 24px" class="el-icon-s-promotion"></span>
                      </template>
                      <template v-else-if="item.type === 'TRIGGER'">
                        <span style="font-size: 24px" class="el-icon-set-up"></span>
                      </template>
                      <template v-else>
                        <template v-if="isDynamicAssignment(item)">
                          <!-- <img
                            src="@/assets/oa/toAssigned.svg"
                            alt="dynamicAddAuditor"
                          /> -->
                        </template>
                        <template v-else>
                          <span style="font-size: 24px" class="iconfont icon-huiyi"
                            v-if="item.result === 'countersign'"></span>
                          <span style="font-size: 24px" class="el-icon-s-custom"
                            v-else-if="item.result === 'selfSelect'"></span>
                          <span v-else>{{ getShortName(item.actor) }}</span>
                        </template>
                      </template>
                    </div>
                    <template v-if="item.result !== 'countersign'">
                      <i v-if="
                        ![
                          'delegate',
                          'withdraw',
                          'dynamicAddAuditor',
                          'rollback',
                        ].includes(item.result)
                      " :class="['status', actionStatusIcon(item)]"></i>
                      <!-- 委托 -->
                      <img class="status" v-else :src="processActionImg[item.result]" :alt="item.result" />
                    </template>
                  </div>
                  <div class="item-user-desc">
                    <div style="color: #8c8c8c; width: 440px">
                      <span v-if="processIndex(item) > 0">第{{ processIndex(item) }}步：</span>{{ item.name
                      }}<span v-if="item.startTime">>开始于：{{ item.startTime }}&nbsp;<a-tag>耗时：{{
                        computedTimeSpent(item.startTime, item.finishTime)
                          }}</a-tag></span>
                    </div>
                    <div style="color: #000000" v-if="!isDynamicAssignment(item)">
                      <template v-if="item.params?.params?.isMobile">
                        <!-- <img
                          style="width: 20px"
                          src="@/assets/oa/dingding.svg"
                          alt="dingding"
                        /> -->
                      </template>
                      {{ item.type === "TRIGGER" ? "触发器" : item.actor }}
                      <template v-if="
                        !(item.type === 'ROOT' && i === 0) &&
                        item.type !== 'CC'
                      ">（<span v-html="actionStatusTitle(item, i)"></span>）</template>
                      <a-button v-if="
                        item.result === 'save' && showRevokedBtn(item.actor)
                      " type="link" icon="undo" class="revoke-btn" title="撤销" @click="revokedAction(item)"></a-button>
                    </div>
                    <div style="color: #ff7d00" v-else>
                      等待节点【<b>{{ approverSelectNodeName(item.props) }}</b>】指定审批人
                    </div>
                  </div>
                </div>
                <div class="action-time">
                  {{ formatFinishTimeLabel(item) }}
                </div>
                <!-- 抄送 -->
                <div class="countersign-warp" v-if="
                  (item.type === 'CC' || item.result === 'cc') &&
                  item.ccUsers &&
                  item.ccUsers.length
                ">
                  <div style="display: flex; flex-direction: column" v-for="cc in item.ccUsers" :key="cc.id + cc.name">
                    <div class="item-user-avatar" style="width: 35px">
                      <div :class="['avatar', cc.type]" style="width: 35px; height: 35px">
                        <i v-if="cc.type === 'dept'" class="iconfont icon-map-site"></i>
                        <span v-else>{{ getShortName(cc.name) }}</span>
                      </div>
                      <i :class="['status other', actionStatusIcon(cc)]"></i>
                    </div>
                    <div>{{ cc.name }}</div>
                  </div>
                </div>
                <!-- 会签 -->
                <div class="countersign-warp" v-if="item.result === 'countersign'">
                  <div style="display: flex; flex-direction: column" v-for="counter in item.countersignedUser"
                    :key="counter.name">
                    <div class="item-user-avatar" style="width: 35px">
                      <div class="avatar" style="width: 35px; height: 35px">
                        <span>{{ getShortName(counter.name) }}</span>
                      </div>
                      <i :class="['status other', actionStatusIcon(counter)]"></i>
                    </div>
                    <div>{{ counter.name }}</div>
                  </div>
                </div>
                <!-- 会签意见 -->
                <div class="comment-warp" v-for="cmt in item.countersignedUser" :key="cmt.name">
                  <template v-if="cmt.comment">
                    <div class="comment-user">
                      <div class="avatar" style="width: 30px; height: 30px">
                        <span style="font-size: 12px">{{
                          getShortName(cmt.name)
                          }}</span>
                      </div>
                      <span>{{ cmt.name }}（添加了评论）</span>
                      <span class="time">{{
                        formatDate(cmt.finishTime, "MM-dd hh:mm:ss")
                        }}</span>
                    </div>
                    <div class="comment-desc" v-if="
                      (cmt.formData && cmt.formData.length) || cmt.comment
                    ">
                      <a-descriptions size="small" :column="2" layout="vertical" bordered
                        v-if="cmt.formData && cmt.formData.length">
                        <a-descriptions-item v-for="params in cmt.formData?.filter((v) => v.value)" :key="params.id"
                          :label="params.name">
                          <!-- 图片 -->
                          <div class="list-photo" v-if="params.id.includes('DDPhotoField')">
                            <img :preview="i" v-for="(img, i) in formatFileList(params)" :key="i"
                              :src="fullPath(img.path)" alt="img" @click="previewImage" />
                          </div>
                          <!-- 附件 -->
                          <div v-else-if="params.id.includes('DDAttachment')">
                            <ul>
                              <li class="file-privew-item" v-for="v in formatFileList(params)" :key="v.id">
                                <div class="link-file" :title="v.title" @click="kkFilePreview(v)">
                                  <img :src="splitFileType(v.title)" style="width: 18px" />
                                  {{ v.title }}
                                </div>
                                <a-tag size="mini" color="blue">{{
                                  formatFileSize(v.size)
                                  }}</a-tag>
                                <!-- <a-button
                                      size="small"
                                      type="primary"
                                      ghost
                                      icon="download"
                                      @click="previewFileHandle(v)"
                                      >下载</a-button
                                  > -->
                              </li>
                            </ul>
                          </div>
                          <span v-else>{{ params.value }}</span>
                        </a-descriptions-item>
                      </a-descriptions>
                      <pre class="comment-text">{{ cmt.comment }}</pre>
                    </div>
                  </template>
                </div>
                <!-- 审批意见 -->
                <div class="comment-warp" v-if="item.comment || (item.formData && item.formData.length)">
                  <div class="comment-desc">
                    <a-collapse v-if="
                      item.formData &&
                      item.formData.length &&
                      item.formData &&
                      item.formData?.filter((v) => v.value).length
                    ">
                      <a-collapse-panel key="formData" header="表单数据详情">
                        <template slot="extra">
                          <a-icon type="eye" />
                        </template>
                        <a-descriptions size="small" :column="2" layout="vertical" bordered>
                          <a-descriptions-item v-for="params in item.formData &&
                            item.formData?.filter((v) => v.value)" :key="params.id" :label="params.name"
                            :span="getFormFieldSpan(params)">
                            <!-- 图片组件 -->
                            <div class="list-photo" v-if="params.id.includes('DDPhotoField')">
                              <img :preview="i" v-for="(img, i) in formatFileList(params)" :key="i"
                                :src="fullPath(img.path)" alt="img" @click="previewImage" />
                            </div>

                            <!-- 附件组件 -->
                            <div v-else-if="params.id.includes('DDAttachment')">
                              <ul class="attachment-list">
                                <li class="file-privew-item" v-for="v in formatFileList(params)" :key="v.id">
                                  <div class="link-file" :title="v.title" @click="kkFilePreview(v)">
                                    <img :src="splitFileType(v.title)" style="width: 18px" />
                                    <span class="file-name">{{ v.title }}</span>
                                  </div>
                                  <div class="file-actions">
                                    <a-tag size="mini" color="blue">{{
                                      formatFileSize(v.size)
                                      }}</a-tag>
                                  </div>
                                  <!-- <a-button
                                      size="small"
                                      type="primary"
                                      ghost
                                      icon="download"
                                      @click="previewFileHandle(v)"
                                      >下载</a-button
                                > -->
                                </li>
                              </ul>
                            </div>

                            <!-- OA流程组件 -->
                            <div v-else-if="params.id.includes('OaProcessField')">
                              <ul class="oa-process-list">
                                <li v-for="v in formatFileList(params)" :key="v.id">
                                  <i class="el-icon-connection"></i>
                                  <span class="oa-process-list__title" @click="viewApprovalProcess(v)">{{ v.serialNumber
                                    }}-{{
                                      v.formTitle
                                    }}</span>
                                </li>
                              </ul>
                            </div>

                            <!-- 文档资料组件 -->
                            <div v-else-if="
                              [
                                'DocumentInformationForm',
                                'DocumentInformationNewForm',
                                'SaleInformationForm',
                                'FunctionalTestingInformationForm',
                              ].includes(params.componentType)
                            ">
                              <div class="document-information-audit">
                                <div class="document-summary-info">
                                  <a-tag color="blue">{{
                                    params.value ||
                                    getDocumentTitle(params.componentType)
                                    }}</a-tag>
                                </div>
                                <div class="document-details-audit" v-if="getDocumentDetails(params).length">
                                  <div v-for="(doc, index) in getDocumentDetails(
                                    params
                                  )" :key="index" class="document-item-audit">
                                    <div class="document-item-header">
                                      <span class="doc-index">{{ index + 1 }}.</span>
                                      <span class="doc-name">{{
                                        doc.name
                                        }}</span>
                                      <a-tag :color="doc.fileName && doc.svnPath
                                        ? 'green'
                                        : 'orange'
                                        " size="small">
                                        {{
                                          doc.fileName && doc.svnPath
                                            ? "已完成"
                                            : "待填写"
                                        }}
                                      </a-tag>
                                    </div>
                                    <div class="document-item-content" v-if="doc.fileName || doc.svnPath">
                                      <div class="document-field-audit">
                                        <span class="field-label">文件名称:</span>
                                        <span class="field-value">{{
                                          doc.fileName || "暂无"
                                          }}</span>
                                      </div>
                                      <div class="document-field-audit">
                                        <span class="field-label">SVN路径:</span>
                                        <span class="field-value svn-path">{{
                                          doc.svnPath || "暂无"
                                          }}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- 表格组件 -->
                            <div v-else-if="params.id.includes('TableField')">
                              <div class="table-wrapper" :style="setTableWrapperStyle">
                                <table border="1" v-if="getFilteredTableHeaders(params).length"
                                  class="form-table audit-table">
                                  <thead>
                                    <tr>
                                      <th width="45">序号</th>
                                      <th v-for="(
column, index
                                        ) in getFilteredTableHeaders(params)" :key="column.key || index"
                                        :style="getColumnStyle(column)">
                                        {{ column.label }}
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(
record, recordIndex
                                      ) in (params.value &&
    JSON.parse(params.value)) ||
    []" :key="recordIndex">
                                      <td class="index-cell">
                                        {{ recordIndex + 1 }}
                                      </td>
                                      <td v-for="(
column, index
                                        ) in getFilteredTableHeaders(params)" :key="column.key || index"
                                        :class="getCellClass(column)">
                                        <div v-if="
                                          column.key.includes('DDPhotoField')
                                        " class="list-photo table-photos">
                                          <img v-for="(img, i) in formatArray(
                                            getColumnValue(record, column.key)
                                          )" :key="i" :src="fullPath(img.path)" alt="img" @click="previewImage" />
                                        </div>

                                        <!-- 附件字段 -->
                                        <div v-else-if="
                                          column.key.includes('DDAttachment')
                                        " class="table-attachments">
                                          <ul>
                                            <li v-for="v in formatArray(
                                              getColumnValue(
                                                record,
                                                column.key
                                              )
                                            )" :key="v.id" class="file-privew-item table-file-item">
                                              <div class="link-file" :title="v.title" @click="kkFilePreview(v)">
                                                <img :src="splitFileType(v.title)" style="width: 16px" />
                                                <span class="file-name">{{
                                                  v.title
                                                  }}</span>
                                              </div>
                                              <div class="file-info">
                                                <a-tag size="mini" color="blue">{{
                                                  formatFileSize(v.size)
                                                }}</a-tag>
                                                <a-button size="small" type="primary" ghost icon="download"
                                                  v-if="showDownload" @click="previewFileHandle(v)">下载</a-button>
                                              </div>
                                            </li>
                                          </ul>
                                        </div>
                                        <!-- 文本域字段 -->
                                        <div v-else-if="
                                          column.key.includes('TextareaField')
                                        " class="table-textarea">
                                          <pre class="textarea-pre table-pre">{{
                                            getColumnValue(record, column.key)
                                          }}</pre>
                                        </div>
                                        <!-- 多选字段 -->
                                        <div v-else-if="
                                          column.key.includes(
                                            'DDMultiSelectField'
                                          )
                                        " class="table-multiselect">
                                          <a-tag v-for="(v, i) in getColumnValue(
                                            record,
                                            column.key
                                          )" :key="i" size="small">{{ v }}</a-tag>
                                        </div>
                                        <!-- 日期范围字段 -->
                                        <div v-else-if="
                                          column.key.includes(
                                            'DDDateRangeField'
                                          )
                                        " class="table-daterange">
                                          <span class="date-start">{{
                                            getColumnValue(
                                              record,
                                              column.key
                                            )[0]
                                          }}</span>
                                          <span class="date-separator">~</span>
                                          <span class="date-end">{{
                                            getColumnValue(
                                              record,
                                              column.key
                                            )[1]
                                          }}</span>
                                        </div>
                                        <!-- 联系人字段 -->
                                        <div v-else-if="
                                          column.key.includes(
                                            'InnerContactField'
                                          )
                                        " class="table-contacts">
                                          <div class="avatar-box contact-item" v-for="user in getColumnValue(
                                            record,
                                            column.key
                                          )" :key="user.id">
                                            <div class="avatar contact-avatar">
                                              {{ getShortName(user.name) }}
                                            </div>
                                            <div class="contact-name">
                                              {{ user.name }}
                                            </div>
                                          </div>
                                        </div>
                                        <!-- 部门字段 -->
                                        <div v-else-if="
                                          column.key.includes(
                                            'DepartmentField'
                                          )
                                        " class="table-departments">
                                          <a-tag v-for="(v, i) in getColumnValue(
                                            record,
                                            column.key
                                          )" :key="i" size="small" color="geekblue">{{ v.name || v }}</a-tag>
                                        </div>
                                        <!-- 普通字段 -->
                                        <div v-else class="table-text">
                                          {{
                                            getTableAmountDisplayValue(
                                              record,
                                              column
                                            )
                                          }}
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            <!-- 多选字段 -->
                            <div v-else-if="
                              params.id.includes('DDMultiSelectField')
                            " class="multiselect-field">
                              <a-tag v-for="(v, i) in formatFileList(params)" :key="i" class="select-tag">{{ v
                                }}</a-tag>
                            </div>

                            <!-- 日期范围字段 -->
                            <div v-else-if="params.id.includes('DDDateRangeField')" class="daterange-field">
                              <span class="date-start">{{
                                formatFileList(params)[0]
                                }}</span>
                              <span class="date-separator">~</span>
                              <span class="date-end">{{
                                formatFileList(params)[1]
                                }}</span>
                            </div>

                            <!-- 联系人字段 -->
                            <div v-else-if="
                              params.id.includes('InnerContactField')
                            " class="contact-field">
                              <div class="avatar-box contact-item" v-for="user in formatFileList(params)"
                                :key="user.id">
                                <div class="avatar contact-avatar">
                                  {{ getShortName(user.name) }}
                                </div>
                                <div class="contact-name">
                                  {{ user.name }}
                                </div>
                              </div>
                            </div>

                            <!-- 部门字段 -->
                            <div v-else-if="params.id.includes('DepartmentField')" class="department-field">
                              <a-tag v-for="(v, i) in formatFileList(params)" :key="i" color="geekblue"
                                class="department-tag">{{ v.name || v }}</a-tag>
                            </div>

                            <!-- 文本域字段 -->
                            <div v-else-if="params.id.includes('TextareaField')" class="textarea-field">
                              <pre class="textarea-pre">{{ params.value }}</pre>
                            </div>

                            <!-- 普通字段 -->
                            <div v-else class="normal-field">
                              <div v-if="isAttachmentBizAlias(params)">
                                <ul>
                                  <li class="file-privew-item" v-for="v in formatFileList(params)" :key="v.id">
                                    <div class="link-file" :title="v.title" @click="kkFilePreview(v)">
                                      <img :src="splitFileType(v.title)" style="width: 18px" />
                                      {{ v.title }}
                                    </div>
                                    <div style="
                                        margin-left: auto;
                                        white-space: nowrap;
                                      ">
                                      <a-tag size="mini" color="blue">{{
                                        formatFileSize(v.size)
                                        }}</a-tag>
                                      <a-button size="small" type="primary" ghost icon="download" v-if="showDownload"
                                        @click="previewFileHandle(v)">下载</a-button>
                                    </div>
                                  </li>
                                </ul>
                              </div>

                            </div>
                          </a-descriptions-item>
                        </a-descriptions>
                      </a-collapse-panel>
                    </a-collapse>
                    <template v-if="item.comment">
                      <pre class="comment-text" v-html="item.comment"></pre>
                    </template>
                  </div>
                  <!-- 加签人/委托人 -->
                  <div class="extra-users" v-if="
                    item.result === 'dynamicAddAuditor' &&
                    item.params &&
                    item.params.auditors &&
                    item.params.auditors.length
                  ">
                    <label>添加审批人：</label>
                    <a v-for="user in item.params.auditors" :key="user.username">{{ user.name }}</a>
                  </div>
                </div>
              </div>
              <div class="process-item">
                <div class="item-user">
                  <span :class="['end-process', stateIconColor(1)]" :style="{ color: stateIconColor(0) }"></span>
                  <span class="end-process-text">{{
                    Number.isInteger(details.state) &&
                    stateAction[details.state][1]
                    }}</span>
                </div>
              </div>
            </div>
          </a-spin>
        </div>

      </div>
      <!-- <div v-else class="no-permission">
         <h3>
          很抱歉，您的访问好像出现了问题！请检查网络权限或者当前浏览器版本！
        </h3>
      </div> -->
    </a-drawer>


  </div>
</template>

<script>
import CopyText from "@/components/CopyText";
import OrgPicker from "@/components/OrgPicker";
import {
  formateValue,
  splitPropsParams,
  flattenTree,
  setFormValue,
  flattenSpanLayoutFields,
  flattenAndFilterFields,
  extractShowFields,
  filterByShowFields,
} from "@/components/approval/approvalUtil";
// import { postAction, downloadFile } from "@/api/manage";
import Vue from "vue";
// import ApprovalInstanceDrawer from "./approvalInstanceDrawer.vue";
// import MaterialVerificationDrawer from "@/views/hardwareManagment/modules/materialVerificationDrawer.vue";
import approvalInstanceMixin from "@/components/approval/approvalInstanceMixin";
import * as u from '@/utils/util'
import * as c from '@/utils/config'
export default {
  name: "approvalInstanceDrawer",
  mixins: [approvalInstanceMixin],
  props: {
    drawerWidth: {
      type: Number,
      default: 980, // 默认宽度
    },
  },
  components: {
     OrgPicker,
    CopyText,
    //  MaterialVerificationDrawer,
  },
  data() {
    return {
      // Drawer专有数据（公共数据在 approvalInstanceMixin 中）
      dataLoading: false,
      visible: false,
      closeLoading: false,
      animateStamp: false,
      isFullscreen: false,
      currentDrawerWidth: this.drawerWidth,
      materialFieldLabelsCache: null,
      filterOriginBizAlias: [],
      auditDeadline: null,
      debounceTimer: null,
      disableProcessRollback: false,
      isEditingFormTitle: false,
      editingFormTitle: "",
      originalFormTitle: "",
      userInfoCache: u.getSession(c.sessionKey.USER_INFO),

    };
  },
  computed: {
    setTableWrapperStyle() {
      return {
        width: this.isFullscreen ? "calc(100vw - 170px)" : "810px",
      };
    },
    // 是否可以编辑表单标题（发起人节点且流程状态为审批中）
    canEditFormTitle() {
      return (
        ["root", "root_hidden"].includes(this.details.activeNodeId) &&
        this.details.state === 1 &&
        this.details.applyUsername === this.userInfoCache.username
      );
    },
    // 是否禁止流程关闭 并且判断发起人是否为当前用户
    forbiddenClose() {
      return (
        this.details?.variables?.forbiddenClose === false &&
        this.details.applyUsername === this.userInfoCache.username
      );
    },
    // 是否禁止驳回
    forbiddenReject() {
      return this.details?.variables?.forbiddenReject !== true
    },

    // OA查看审批详情默认配置全屏访问人
    isFullscreenView() {
      return ["zhuh"].includes(this.userInfoCache.username);
    },
    processIndex() {
      return (item) => {
        if (this.sequenceFlowIds.length) {
          return (
            this.sequenceFlowIds
              .filter((v) => v !== "root_hidden")
              .findIndex((v) => v === item.id) + 1
          );
        } else {
          return 0;
        }
      };
    },
    limitTableWidth() {
      if (this.isFullscreen) {
        return {
          width: "100%",
        };
      } else {
        return {
          width: "748px", // 810px
        };
      }
    },
     // OA控件组列表
        oaComponentList() {
            return [
                'SpanLayoutField',
                'OrderReviewForm',
                'ProjectInfoForm',
                'ProjectCostDataForm',
                'FirmwarePartNumberReferenceForm',
                'FirmwarePartNumberCreateForm',
                'MeterTypeForm',
                'MaterialForm',
                'ADMaterialGroupForm',
                'FirmwareInformationForm',
                'HardwareInformationForm',
                'SoftwareInformationForm',
                'StructuralInformationForm',
                'ProcessFileInformationForm',
                'DocumentInformationForm',
                'DocumentInformationNewForm',
                'SchemeChangeForm',
                'SaleInformationForm',
                'FunctionalTestingInformationForm'
                // 'ParseFirmwareVersionForm'
            ]
        },
    showComponent() {
      return function (componentType) {
        return this.oaComponentList
          .filter(
            (v) =>
              ![
                "DocumentInformationForm",
                "DocumentInformationNewForm",
                "SaleInformationForm",
                "FunctionalTestingInformationForm",
              ].includes(v)
          )
          .includes(componentType);
      };
    },
    computedOverTime() {
      if (!this.auditDeadline) return "";
      const overdueTime = this.now - new Date(this.auditDeadline).getTime();
      return this.formatDuration(overdueTime);
    },
    isDely() {
      return (
        this.auditDeadline &&
        new Date(this.auditDeadline).getTime() > Date.now()
      );
    },

    // 去重处理审批人节点、根据id&type&result&actor&actionId 判断是否重复
    uniqueProcessActionList() {
      if (!Array.isArray(this.processActionList)) {
        return [];
      }

      return this.processActionList
        .filter(
          (v, index, self) =>
            self.findIndex(
              (t) =>
                t.id === v.id &&
                t.type === v.type &&
                t.result === v.result &&
                t.actor === v.actor &&
                t.actionId === v.actionId
            ) === index
        )
        .filter((v) => {
          if (this.details.state !== 1) {
            return !["pending", "processing"].includes(v.result);
          } else {
            return true;
          }
        });
        
    },
    // 获取表单字段的跨列数
    getFormFieldSpan() {
      return (params) => {
        // 表格、图片、附件、文档资料等组件占用两列
        if (
          params.id.includes("TableField") ||
          params.id.includes("DDPhotoField") ||
          params.id.includes("DDAttachment") ||
          params.id.includes("OaProcessField") ||
          params.id === "DocumentInformationForm" ||
          params.componentType === "DocumentInformationForm" ||
          params.id.includes("TextareaField")
        ) {
          return 2;
        }
        return 1;
      };
    },
    // 新增：获取列样式
    getColumnStyle() {
      return (column) => {
        if (column.key.includes("DDAttachment")) {
          return { width: "240px" };
        }
        if (column.key.includes("DepartmentField")) {
          return { width: "140px" };
        }
        return { width: "100px" };
      };
    },
    // 新增：获取单元格样式类
    getCellClass() {
      return (column) => {
        const classes = ["table-cell"];
        if (column.key.includes("DDPhotoField")) {
          classes.push("photo-cell");
        } else if (column.key.includes("DDAttachment")) {
          classes.push("attachment-cell");
        } else if (column.key.includes("TextareaField")) {
          classes.push("textarea-cell");
        } else if (column.key.includes("DDMultiSelectField")) {
          classes.push("multiselect-cell");
        } else if (column.key.includes("InnerContactField")) {
          classes.push("contact-cell");
        } else if (column.key.includes("DepartmentField")) {
          classes.push("department-cell");
        }
        return classes.join(" ");
      };
    },
  },
  watch: {
    "form.formData": {
      handler(newVal) {
        if (!newVal) return;

        // 过滤出perm为'E'的可编辑组件
        const editableFormComponents = this.editableComponents.filter(
          (item) => item.perm === "E"
        );

        const editableVariables = {};
        editableFormComponents
          .filter((item) => item.bizAlias)
          .forEach((item) => {
            editableVariables[item.bizAlias] = newVal[item.id];
          });
        // 判断对象editableVariables的value有值
        if (
          this.details.bpmn &&
          Object.values(editableVariables).some((value) => value)
        ) {
          // this.setProcessActionList();
          this.debouncedGetApprovalnodeprediction(editableVariables); // 使用防抖版本
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    isAttachmentBizAlias(field) {
      if (!field) return false
      return field.bizAlias ? /attachment/i.test(field.bizAlias) : false
    },
    onClose() {
      this.visible = false;
      this.$emit("close");
    },
    show(record, taskId = "") {
      // console.log("🚀 ~ record:", record)
      this.isFullscreen = this.isFullscreenView;
      this.currentDrawerWidth = this.isFullscreenView ? window.innerWidth : 980;
      this.visible = true;
      this.recordId = record.processInstanceId;
      this.dataLoading = true;
      this.$nextTick(() => {
        const processContent = document.querySelector(".process-content");
        if (processContent) {
          processContent.scrollTop = 0; // 设置滚动位置为顶部
        }
      });
      // this.form.taskId = taskId; // 审核待办时，传入taskId
      this.form.special = record.special;
      this.form.suspend = record.suspend;
      // if (this.form.taskId) {
      //   this.markRead(this.form.taskId);
      // }
      this.getApprovalInstanceDetails();
      this.handleVisibleChange();
    },
     /**
     * 获取审批实例详情
     */
      getApprovalInstanceDetails() {
      // try {
        this.$HttpService
        .post('/workflow/forminstance/getbyid', {
          id: this.recordId
        }).then((res) =>{
          this.details = res;

          if (!this.details) return
  
          let formData = [...this.details.formData]
          this.details.formData = flattenSpanLayoutFields(
            this.details.formComponents,
            formData
          )
    this.dataLoading = false;
          const variables = res.variables || {}
          this.orginVariables = variables
          this.attachmentListAction = res.actions.filter(
            (v) => v.action === 'addAttachment'
          )
  
          const actions = res.actions.filter((v) => v.action !== 'addAttachment')
          this.fullApprovalActionList = actions
          console.log("🚀 ~ this.fullApprovalActionList:", this.fullApprovalActionList)
  
          let process = flattenTree(JSON.parse(res.bpmn), false) || []
          this.processOriginNodeList = flattenTree(JSON.parse(res.bpmn))
  
          const conditionNodeIndex = process.findIndex(
            (v) => v.type === 'CONDITIONS'
          )
          process =
            conditionNodeIndex === -1
              ? process
              : process.slice(0, conditionNodeIndex)
          this.initailProcessList = process
  
          this.setProcessActionList()
          this.$set(this.form, 'variables', {})
  
          this.processFormPermissions(process)
          const isEditable =
            this.editableComponents.length &&
            this.editableComponents.filter((v) => v.value).length
          if (!isEditable) {
            this.getApprovalnodeprediction()
          }
  
          this.getFormDataValue()
        })
       
      // } catch (error) {
      //   console.error('获取审批实例详情失败:', error)
      //   this.details = {}
      //   this.orginVariables = {}
      //   this.attachmentListAction = []
      //   this.fullApprovalActionList = []
      //   this.processOriginNodeList = []
      //   this.processActionList = []
      //   this.toProcessNodeList = []
      //   this.editableComponents = []
      // }
    },
    // 获取审批实例详情
    // getApprovalInstanceDetails() {
    //   // try {
    //   this.$HttpService
    //     .post("/workflow/forminstance/getbyid", {
    //       id: this.recordId,
    //     }).then((res) => {
    //       console.log("🚀 ~ res:", res)
    //       this.details = res;
    //       this.getApprovalnodeprediction();
    //       this.setProcessActionList();
    //       console.log("🚀 ~  this.details :", this.details)
    //       // 记录初始标题用于变更判断
    //       this.originalFormTitle = res.formTitle || "";
    //       this.disableProcessRollback =
    //         (this.details.extendInfo &&
    //           this.details.extendInfo.disableProcessRollback) ||
    //         false;
    //       this.dataLoading = false;
    //       if (!this.details) return;
    //       let formData = [...this.details.formData];
    //       // 示例：提取控件组中 showFields 指定的字段
    //       if (this.details.formComponents) {
    //         const extractedFields = extractShowFields(
    //           this.details.formComponents
    //         );
    //         const filteredComponents = filterByShowFields(
    //           this.details.formComponents
    //         );

    //         this.details.formData = flattenSpanLayoutFields(
    //           filteredComponents,
    //           formData
    //         );
    //       }

    //       // 判断是否需要全屏
    //       if (
    //         this.details.formData.some(
    //           (v) => v.componentType === "TableField" && v.children.length > 10
    //         )
    //       ) {
    //         this.isFullscreen = true;
    //         this.currentDrawerWidth = window.innerWidth;
    //       } else {
    //         this.isFullscreen = this.isFullscreenView;
    //         this.currentDrawerWidth = this.isFullscreenView
    //           ? window.innerWidth
    //           : 980;
    //       }
    //       let copyFormData = [...this.details.formData];
    //       let processedData = copyFormData.map((curr) => {
    //         let resItem = { ...curr };
    //         // 处理相关显示逻辑
    //         if (curr.props.extendProps.relatedDisplay) {
    //           const relatedField = curr.props.extendProps.relatedField;
    //           const relatedValue = curr.props.extendProps.relatedValue;
    //           const relatedItem = copyFormData.find(
    //             (item) => item.bizAlias === relatedField
    //           );

    //           if (relatedItem) {
    //             resItem.isRelatedDisplay = relatedItem.value !== relatedValue;
    //           }
    //         }
    //         return resItem;
    //       });
    //       this.details.formData = processedData;
    //       const variables = res.variables || {};
    //       this.orginVariables = variables; // 保存人员变量
    //       this.attachmentListAction = res.actions.filter(
    //         (v) => v.action === "addAttachment"
    //       ); // 添加附件的action

    //       // 过滤掉添加附件的action
    //       const actions = res.actions.filter(
    //         (v) => v.action !== "addAttachment"
    //       );
    //       this.fullApprovalActionList = actions; // 保存完整审批动作列表
    //       let process = flattenTree(JSON.parse(res.bpmn), false) || [];
    //       this.processOriginNodeList = flattenTree(JSON.parse(res.bpmn));
    //       // 截取type为CONDITIONS以后的节点
    //       const conditionNodeIndex = process.findIndex(
    //         (v) => v.type === "CONDITIONS"
    //       );
    //       process =
    //         conditionNodeIndex === -1
    //           ? process
    //           : process.slice(0, conditionNodeIndex);
    //       this.initailProcessList = process;
        
    //       this.$set(this.form, "variables", {});

    //       // 处理表单权限和组件
    //       this.processFormPermissions(this.processOriginNodeList);

    //       this.filterOriginBizAlias = flattenAndFilterFields(
    //         this.editableComponents
    //       );
    //       // 处理动态组件数据回显
    //       this.getFormDataValue();
    //     });;

    //   // } catch (error) {
    //   //   this.dataLoading = false;
    //   //   this.details = {};
    //   //   this.orginVariables = {};
    //   //   this.attachmentListAction = [];
    //   //   this.fullApprovalActionList = [];
    //   //   this.processOriginNodeList = [];
    //   //   this.processActionList = [];
    //   //   this.toProcessNodeList = [];
    //   //   this.editableComponents = [];
    //   //   console.error("获取审批实例详情失败:", error);
    //   // }
    // },
    // 获取formData值
    getFormDataValue() {
      this.$set(this.form, "formData", {});
      if (this.editableComponents.length && this.form.taskId) {
        if (this.details.formData && this.details.formData.length > 0) {
          this.details.formData.forEach((item) => {
            if (this.editableComponents.some((v) => v.id === item.id)) {
              // 特殊处理 DocumentInformationForm 组件
              if (
                [
                  "DocumentInformationForm",
                  "DocumentInformationNewForm",
                  "SaleInformationForm",
                  "FunctionalTestingInformationForm",
                ].includes(item.componentType)
              ) {
                this.processDocumentInformationFormValue(item);
              } else {
                this.$set(this.form.formData, item.id, setFormValue(item));
              }
            }
          });
        }
      }
    },
    // 获取流程预测（覆盖mixin版本：增加防抖和流程预测完整节点处理）
    getApprovalnodeprediction(variables = {}) {
      let params = {
        bpmn: this.details.bpmn,
        variables: {},
      };
      const filterBizAlias =
        (this.details.formData &&
          this.details.formData.filter((v) => v.bizAlias)) ||
        [];
      //   if (!filterBizAlias.length) return;
      filterBizAlias.map((item) => {
        params.variables[item.bizAlias] = item.value || "";
      });
      params.variables = {
        ...params.variables,
        ...variables,
        ...this.details.variables,
      };
      params.applyUsername = this.details.applyUsername;
      
      const currentNodeIdIndex = this.processOriginNodeList.findIndex(
        (v) => v.id === this.details.activeNodeId
      );
      this.toProcessNodeList = this.processOriginNodeList.slice(
        0,
        currentNodeIdIndex
      );
      // 处理动态审批人节点
      this.groupDynamicActiveNodeItems();
      // 获取完整流程节点
      this.getSequenceFlowIdsList(params);
     },
    // 获取流程预测
    getSequenceFlowIdsList(params) {
      let requestParams = params || {
        bpmn: this.details.bpmn,
        variables: {},
      };
      this.$HttpService
        .post(
          "/workflow/forminstance/approvalnodeprediction",
          requestParams
        ).then((res) => {
          const nodepredictDetails = res || {};
          this.sequenceFlowIds =
            (nodepredictDetails.variables &&
              nodepredictDetails.variables.sequenceFlowIds) ||
            [];
        });
    },
    // 处理表单权限和组件
    processFormPermissions(process) {
      const currentNodeProcess = process.find(
        (v) => v.id === this.details.activeNodeId
      );

      // 判断是否为发起人节点（root节点）
      const isRootNode = ["root", "root_hidden"].includes(
        this.details.activeNodeId
      );
      if (currentNodeProcess) {
        const formPerms = currentNodeProcess.props?.formPerms || [];
        this.details.formData.forEach((item) => {
          const formPermsItem = formPerms.find((v) => v.id === item.id);
          if (item.perm === "R") {
            this.$set(item, "perm", "H");
          } else {
            this.$set(item, "perm", formPermsItem ? formPermsItem.perm : "H");
          }
        });
      }

      // 处理可编辑组件
      const editableComponentList = this.details.formData.map((item) => {
        return {
          ...item,
          children:
            item.children && item.children.length > 0
              ? item.children
              : this.details.formComponents.find(
                (v) => v.props?.componentId === item.props?.componentId
              )?.children || [],
        };
      });
      // 递归处理组件及其子组件的props.extendProps
      const processComponentRecursively = (component) => {
        const processedComponent = {
          ...splitPropsParams(component),
          props: {
            ...component.props,
            ...component.props.extendProps,
            options: ["DDSelectField", "DDMultiSelectField"].includes(
              component.componentType
            )
              ? component.props.options &&
              component.props.options.map((v) => v.value)
              : undefined,
          },
        };

        // 递归处理children
        if (component.children && Array.isArray(component.children)) {
          processedComponent.props.children = component.children.map((child) =>
            processComponentRecursively(child)
          );
        }

        return processedComponent;
      };

      this.editableComponents = editableComponentList.map((item) => {
        return processComponentRecursively(item);
      });
      this.details.formData = this.details.formData.filter(
        (item) => item.perm !== "E" || item.perm !== "H"
      ); // 只显示可读组件
      // 根据类型进行布局调整
      if (this.details.formData.length) {
        this.details.formData.forEach((item, i) => {
          if (
            [
              "DDPhotoField",
              "DDDateRangeField",
              "TextareaField",
              "DDAttachment",
            ].includes(item.componentType)
          ) {
            this.$set(item, "span", 2);
            if (i % 2 === 0 && i > 0) {
              this.$set(this.details.formData[i - 1], "span", 2);
            }
          }
          if (item.bizAlias === "category") {
            this.$set(
              item,
              "value",
              item.value
                ? isNaN(Number(item.value))
                  ? item.value
                  : Number(item.value)
                : ""
            );
          }
        });
      }
    },
    handleVisibleChange(visible) {
      if (this.visible) {
        this.animateStamp = false; // 重置动画状态
        this.$nextTick(() => {
          this.animateStamp = true; // 触发动画
        });
      }
    },
 approvalInstanceDrawerStyle() {
      let customStyle = {};
      if (this.form.taskId || this.details.state === 1) {
        // customStyle["height"] = "calc(100% - 154px)";
        customStyle["height"] = "calc(100% - 136px)";
      } else {
        customStyle["height"] = "calc(100% - 84px)";
      }
      return customStyle;
    },
    // 全屏切换
    toggleScreen() {
      if (!this.isFullscreen) {
        this.currentDrawerWidth = window.innerWidth;
      } else {
        this.currentDrawerWidth = this.drawerWidth;
      }
      this.isFullscreen = !this.isFullscreen;
    },
  },
  beforeDestroy() {
    // 清理防抖定时器，防止内存泄漏
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = null;
    }
  },

};
</script>

<style lang="less" scoped>
::v-deep .ant-divider-horizontal {
  margin: 16px 0 0 !important;
}

::v-deep .ant-descriptions-item-label {
  color: #858e99;
  width: 130px !important;
  line-height: 1 !important;
  padding: 6px 12px !important;
}

::v-deep .ant-descriptions-item-content {
  padding: 6px 10px !important;
  min-width: 200px !important;
}

::v-deep .ant-drawer-body {
  height: calc(100% - 55px);
  padding: 0;
}

::v-deep .ant-form-item-label {
  height: 30px;
  line-height: 30px;
}

.form-name {
  width: 100px !important;
  white-space: normal;

  &.hidden {
    display: none !important;
  }
}

.user-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.avatar-box {
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  white-space: nowrap;

  .add-user {
    padding: 8px;
    font-size: 18px;
    border-radius: 50%;
    border: 1px dashed #8c8c8c;
    color: #333;
    cursor: pointer;

    &:hover {
      border-color: #1890ff;
      color: #1890ff;
    }
  }

  .close {
    position: absolute;
    top: 0;
    right: 0;
    color: #fff;
    cursor: pointer;
    border-radius: 50%;
    background: #000;
  }

  .name {
    line-height: 22px;
  }
}

.avatar {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1890ff;
  color: white;
  border-radius: 50%;

  &.dept {
    background: #f77234;
  }
}

.drawer-content {
  background: #eee;
  position: relative;
  height: 100%;

  .title {
    background: #fff;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    position: relative;
    padding: 10px;
    gap: 16px;

    .title-info {
      display: flex;
      flex-direction: column;
      gap: 6px;

      .form-title {
        display: flex;
        align-items: center;
        gap: 12px;

        .form-title-text {
          max-width: 550px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          &.editable-title {
            cursor: pointer;
            padding: 2px 4px;
            border-radius: 4px;
            transition: all 0.3s;

            &:hover {
              background-color: #f0f0f0;
              color: #1890ff;
            }
          }
        }
      }
    }

    .extend-options {
      margin-left: auto;
    }
  }

  .status-icon {
    position: absolute;
    right: 50px;
    top: 35px;
    z-index: 999;
    transform: scale(0);
    opacity: 0;
  }

  .process-content {
    overflow-y: auto;
  }

  .animate-stamp {
    animation: stampEffect 0.8s cubic-bezier(0.68, -0.55, 0.27, 1.55) forwards;
  }

  @keyframes stampEffect {
    0% {
      transform: scale(0) rotate(0deg);
      opacity: 0;
    }

    30% {
      transform: scale(1.5) rotate(-20deg);
      opacity: 1;
    }

    60% {
      transform: scale(0.9) rotate(10deg);
      opacity: 1;
    }

    80% {
      transform: scale(1.1) rotate(-5deg);
      opacity: 1;
    }

    100% {
      transform: scale(1) rotate(0deg);
      opacity: 1;
    }
  }

  .form-render {
    margin: 16px 0;
    padding: 10px 12px;
    background: #fff;

    // font-family: "SimSun", serif !important;
    .form-table {
      position: relative;
      width: 100%;
      //   max-width: 820px;
      border-collapse: collapse;

      // margin-bottom: 16px;
      .form-label,
      td {
        text-align: left;
        padding: 6px 8px;
        // word-break: break-all;
        min-width: 60px;
        max-width: 600px;
        border: 1px solid #000000d9;
      }
    }

    .form-label {
      line-height: 20px;
    }

    .form-item-value {
      line-height: 1.1;
    }
  }

  .process {
    background: #fff;
    padding: 16px 12px;

    .process-item {
      z-index: 1;
      padding-bottom: 30px;
      position: relative;

      .item-user {
        display: flex;
        align-items: center;
        gap: 12px;

        .end-process {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          font-size: 28px;
          border-radius: 50%;
          background: #fff;
        }

        .end-process-text {
          font-size: 16px;
          color: #000000;
        }
      }

      .action-time {
        font-size: 15px;
        color: #8a8a8a;
        position: absolute;
        right: 0;
        top: 0;
      }

      .countersign-warp {
        margin-left: 50px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 20px;
      }
    }

    .progress-item-his {
      &::before {
        content: "";
        position: absolute;
        width: 4px;
        top: 0;
        left: 18px;
        color: #e4e4e4;
        background: #e4e4e4;
        height: 100%;
      }
    }
  }

  .comment-warp {
    margin-left: 50px;
    font-size: 14px;
    position: relative;

    .comment-user {
      white-space: nowrap !important;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;

      .time {
        margin-left: auto;
      }
    }

    .comment-desc {
      margin: 5px 0;
      background: #eee;
      padding: 8px 12px;
      border-radius: 0 5px 5px 5px;

      ::v-deep .ant-descriptions-view,
      ::v-deep .ant-descriptions-row,
      ::v-deep .ant-descriptions-item-label {
        border-color: #faad14 !important;
      }

      ::v-deep .ant-descriptions-item-content {
        background: cornsilk !important;
        border-color: #faad14 !important;
      }

      .comment-text {
        margin-bottom: 0;
        white-space: break-spaces;
        word-break: break-all;
        width: 100%;
        line-height: 20px;
      }
    }

    .extra-users {
      margin-top: 4px;
      line-height: 22px;
      word-break: break-all;
      white-space: break-spaces;
    }
  }

  .list-photo {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;

    &>img {
      border: 4px solid #ccc;
      border-radius: 6px;
      height: 80px;
      cursor: zoom-in;
    }
  }

  .attachment-warp {
    background: #fff;
    padding: 0 12px;
    margin-top: 16px;
  }

  .actions-warp {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 20px 12px 10px;
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    z-index: 99;
    background: #fff;
    border-top: 1px solid #dcdfe6;
    box-shadow: 0 0 15px 0 #dad8d8;

    .comment {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      color: #000000;

      &>i {
        font-size: 20px;
      }

      &:hover {
        color: #1890ff;
      }
    }

    .self-botton {
      height: 32px;
      line-height: 32px;
      width: 75px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      gap: 8px;
      color: #000000;

      &>i {
        font-size: 20px;
      }

      &:hover {
        background: #f5f7fa;
        color: #1890ff;
      }
    }
  }
}

.item-user-avatar {
  background: #fff;
  position: relative;
  padding: 4px 0;

  .status {
    position: absolute;
    bottom: -4px;
    right: -8px;
    border-radius: 50%;
    font-size: 15px;
    background: #fff;
    border: 2px solid #fff;

    &.other {
      bottom: -4px;
      right: -8px;
    }

    &.success {
      color: #35b881;
    }

    &.loading {
      color: #1890ff;
    }

    &.pending {
      // color: #1890ff;
      background: #f78f5f;
      color: #fff;
      border-color: #fff;
    }

    &.reject {
      color: #f56c6c;
    }

    &.close {
      color: #808080;
    }
  }
}

.file-privew-item {
  display: flex;
  align-items: center;

  .link-file {
    height: 28px;
    line-height: 28px;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    text-align: left;
     word-break: break-all;

    &:hover {
      background: #f5f7fa;
    }
  }

  .down-icon {
    height: 20px;
    cursor: pointer;
  }
}

.sign-overlay {
  color: #000000;
  display: flex;
  align-items: center;
  gap: 6px;

  &>i {
    font-size: 18px;
  }
}

.textarea-pre {
  margin-bottom: 0;
  white-space: break-spaces;
  word-break: break-all;
  width: 100%;
  line-height: 20px;
}

.serial-number {
  display: flex;
  color: #666666 !important;
}

.required-mark {
  color: #f5222d;
  font-size: 14px;
  margin-right: 4px;
  font-family: SimSun, sans-serif;
  line-height: 1;
}

.span-layout-title {
  margin-top: 0;
  font-weight: 600;

  &>span {
    font-size: 14px;
  }
}

.no-permission {
  height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;

  &>h3 {
    font-size: 24px;
    font-weight: 600;
    color: #6e6e96;
    text-align: center;
  }
}

.oa-process-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 6px;
  color: #1890ff;

  &>li {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 8px;
    border-radius: 4px;
    cursor: pointer;
    background-color: #fafafa;

    &:hover {
      background-color: #f0f0f0;
    }

    .oa-process-list__title {
      max-width: 280px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.revoke-btn {
  font-size: 18px;
}

/* 物料表单显示样式 */
.material-form-view {
  padding: 8px;
  width: 100%;
  background-color: #f9f9f9;
  border-radius: 4px;

  .material-item-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .material-item {
    display: flex;
    align-items: center;
    line-height: 1.5;
    padding: 4px 0;
    border-bottom: 1px dashed #eaeaea;

    &:last-child {
      border-bottom: none;
    }

    .material-item-label {
      font-weight: 500;
      margin-right: 8px;
      color: #5a5a5a;
      min-width: 90px;
      padding-right: 5px;
      position: relative;

      &::after {
        content: ":";
        position: absolute;
        right: 0;
        color: #8c8c8c;
      }
    }

    .material-item-value {
      color: #262626;
      word-break: break-all;
      flex: 1;
      line-height: 1.1;

      // 特殊字段样式
      .brand-value {
        color: #1890ff;
        font-weight: 500;
      }

      .code-value {
        font-family: monospace;
        background-color: #f0f0f0;
        padding: 0 4px;
        border-radius: 2px;
      }

      .status-value {
        padding: 2px 8px;
        border-radius: 10px;
        font-size: 12px;

        &.status-yes {
          background-color: #e6f7ff;
          color: #1890ff;
        }

        &.status-no {
          background-color: #fff2e8;
          color: #fa8c16;
        }
      }
    }
  }

  // 紧凑模式（表格内）
  &.compact-mode {
    padding: 4px;
    background-color: transparent;

    .material-item-list {
      gap: 0;
    }

    .material-item {
      padding: 2px 0;
      margin-bottom: 2px;
      border-bottom: none;

      .material-item-label {
        min-width: 55px;
        font-size: 12px;
      }

      .material-item-value {
        font-size: 12px;
      }
    }
  }
}

th {
  // min-width: 60px;
  line-height: 1.1;
  border: 1px solid #000000d9;
}

/* 固件版本信息卡片样式 */
.firmware-version-cell {
  min-width: 200px;
  max-width: 360px;
}

.firmware-card {
  background: #f7f8fa;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 6px 10px;
  font-size: 12px;
  line-height: 1.6;

  &+.firmware-card {
    margin-top: 6px;
  }

  .firmware-card-header {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 4px;
  }

  .firmware-tag {
    display: inline-block;
    background: #1890ff;
    color: #fff;
    font-size: 11px;
    padding: 0 6px;
    border-radius: 2px;
    line-height: 20px;
    font-weight: 500;
  }

  .firmware-processor {
    color: #8c8c8c;
    font-size: 11px;
  }

  .firmware-card-row {
    display: flex;
    align-items: baseline;
    gap: 4px;
  }

  .firmware-label {
    color: #8c8c8c;
    white-space: nowrap;
    flex-shrink: 0;

    &::after {
      content: "：";
    }
  }

  .firmware-value {
    color: rgba(0, 0, 0, 0.65);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .firmware-file-link {
    color: #1890ff;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 260px;
    display: inline-block;
    vertical-align: bottom;

    &:hover {
      text-decoration: underline;
    }
  }
}

/* 文档资料信息显示样式 */
.document-information-display {
  width: 100%;
  padding: 16px;
  background-color: #fafafa;
  border-radius: 8px;
  border: 1px solid #e8e8e8;

  .document-summary-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #e8e8e8;

    .document-title {
      margin: 0;
      color: #262626;
      font-size: 16px;
      font-weight: 600;
      display: flex;
      align-items: center;
    }

    .document-status {
      .ant-tag {
        margin: 0;
      }
    }
  }

  .document-details-list {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .document-item-detail {
      background: #fff;
      border: 1px solid #e8e8e8;
      border-radius: 6px;
      padding: 12px;
      transition: all 0.3s ease;

      &:hover {
        border-color: #d9d9d9;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
      }

      .document-item-header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 8px;

        .doc-index {
          font-weight: 600;
          color: #1890ff;
          font-size: 14px;
          min-width: 20px;
        }

        .doc-name {
          font-weight: 500;
          color: #262626;
          font-size: 14px;
          flex: 1;
        }

        .ant-tag {
          margin: 0;
        }
      }

      .document-item-content {
        margin-left: 28px;
        display: flex;
        flex-direction: column;
        gap: 6px;

        .document-field {
          display: flex;
          align-items: flex-start;

          .field-label {
            color: #666;
            font-size: 12px;
            min-width: 60px;
            max-width: 600px;
            margin-right: 8px;
            font-weight: 500;
          }

          .field-value {
            color: #262626;
            font-size: 12px;
            word-break: break-all;
            flex: 1;
            line-height: 1.4;

            &.svn-path {
              font-family: monospace;
              background-color: #f5f5f5;
              padding: 2px 4px;
              border-radius: 2px;
              font-size: 12px;
            }
          }
        }
      }
    }
  }

  .no-document-data {
    text-align: center;
    padding: 40px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

/* 审批意见中的组件样式优化 */
::v-deep .comment-desc .ant-descriptions-item-content {
  padding: 8px 12px !important;
}

/* 附件列表样式 */
.attachment-list {
  margin: 0;
  padding: 0;
  list-style: none;

  .file-privew-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 0;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }

    .link-file {
      display: flex;
      align-items: center;
      gap: 6px;
      flex: 1;
      min-width: 0;

      .file-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .file-actions {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-left: 12px;
    }
  }
}

/* 文档资料审批展示样式 */
.document-information-audit {
  width: 100%;

  .document-summary-info {
    margin-bottom: 12px;

    .ant-tag {
      margin: 0;
    }
  }

  .document-details-audit {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .document-item-audit {
      background: #fafafa;
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      padding: 8px;

      .document-item-header {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-bottom: 6px;

        .doc-index {
          font-weight: 600;
          color: #1890ff;
          font-size: 12px;
          min-width: 18px;
        }

        .doc-name {
          font-weight: 500;
          color: #262626;
          font-size: 12px;
          flex: 1;
        }

        .ant-tag {
          margin: 0;
        }
      }

      .document-item-content {
        margin-left: 24px;
        display: flex;
        flex-direction: column;
        gap: 4px;

        .document-field-audit {
          display: flex;
          align-items: flex-start;

          .field-label {
            color: #666;
            font-size: 11px;
            min-width: 50px;
            margin-right: 6px;
            font-weight: 500;
          }

          .field-value {
            color: #262626;
            font-size: 11px;
            word-break: break-all;
            flex: 1;
            line-height: 1.3;

            &.svn-path {
              font-family: monospace;
              background-color: #f5f5f5;
              padding: 1px 3px;
              border-radius: 2px;
            }
          }
        }
      }
    }
  }
}

/* 表格组件在审批意见中的样式 */
.table-wrapper {
  width: 810px;
  overflow-x: auto;
  box-shadow: inset -15px 0 15px -10px rgba(114, 113, 113, 0.2);

  .audit-table {
    min-width: 100%;
    font-size: 12px;

    th,
    td {
      padding: 4px 6px !important;
      border: 1px solid #e8e8e8 !important;
      text-align: left;
    }

    th {
      background-color: #fafafa;
      font-weight: 600;
      color: #262626;
    }

    .index-cell {
      text-align: center;
      width: 40px;
      min-width: 40px;
    }

    .table-cell {
      vertical-align: top;

      &.photo-cell {
        min-width: 120px;
      }

      &.attachment-cell {
        min-width: 150px;
      }

      &.textarea-cell {
        min-width: 200px;
      }

      &.contact-cell {
        min-width: 100px;
      }
    }
  }

  .table-photos {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;

    img {
      width: 64px;
      height: 64px;
      object-fit: cover;
      border: 2px solid #ccc;
      border-radius: 4px;
    }
  }

  .table-attachments {
    ul {
      margin: 0;
      padding: 0;
      list-style: none;
    }

    .table-file-item {
      display: flex;
      gap: 2px;
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0;
      }

      .link-file {
        display: flex;
        align-items: center;
        gap: 4px;

        .file-name {
          font-size: 11px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .file-info {
        display: flex;
        align-items: center;
        gap: 4px;
        margin-top: 2px;
        margin-left: auto;

        .ant-tag {
          margin: 0;
          font-size: 10px;
        }

        .ant-btn {
          padding: 0 4px;
          height: 20px;
          font-size: 10px;
        }
      }
    }
  }

  .table-textarea {
    .table-pre {
      margin: 0;
      font-size: 11px;
      line-height: 1.3;
      max-height: 60px;
      overflow-y: auto;
    }
  }

  .table-multiselect {
    display: flex;
    flex-wrap: wrap;
    gap: 2px;

    .ant-tag {
      margin: 0;
      font-size: 10px;
    }
  }

  .table-daterange {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;

    .date-separator {
      color: #999;
    }
  }

  .table-contacts {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;

    .contact-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2px;

      .contact-avatar {
        width: 24px;
        height: 24px;
        font-size: 10px;
      }

      .contact-name {
        font-size: 10px;
        text-align: center;
        max-width: 60px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .table-departments {
    display: flex;
    flex-wrap: wrap;
    gap: 2px;

    .ant-tag {
      margin: 0;
      font-size: 10px;
    }
  }

  .table-text {
    font-size: 11px;
    line-height: 1.3;
    word-break: break-all;
  }
}

/* 审批意见中各字段类型的样式 */
.multiselect-field {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;

  .select-tag {
    margin: 0;
  }
}

.daterange-field {
  display: flex;
  align-items: center;
  gap: 8px;

  .date-separator {
    color: #999;
    font-weight: 500;
  }

  .date-start,
  .date-end {
    color: #262626;
  }
}

.contact-field {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;

  .contact-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;

    .contact-avatar {
      width: 32px;
      height: 32px;
      font-size: 12px;
    }

    .contact-name {
      font-size: 12px;
      text-align: center;
      max-width: 80px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.department-field {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;

  .department-tag {
    margin: 0;
  }
}

.textarea-field {
  .textarea-pre {
    margin: 0;
    font-size: 12px;
    line-height: 1.4;
    max-height: 120px;
    overflow-y: auto;
  }
}

.normal-field {
  .field-value {
    color: #262626;
    font-size: 13px;
    line-height: 1.4;
    word-break: break-all;
  }
}

.table-warpper {
  width: 100%;
  overflow-x: auto;
  box-shadow: inset -15px 0 15px -10px rgba(114, 113, 113, 0.2);
}

.drawer-title-left {
  display: flex;
  align-items: center;
  gap: 8px;

  .back-icon {
    cursor: pointer;
    font-size: 14px;
    color: #606266;
    margin-right: 4px;
  }
}

/deep/ .ant-drawer-header {
  padding: 15px 24px !important;
}
</style>
